import React from 'react'
import {Box, Typography} from '@mui/material'
import {useAppSelector} from 'src/hooks'
import {NEUTRAL_SCALE} from 'src/theme-new/tokens'

const FooterDisclaimer = (): JSX.Element | null => {
  const footerConfiguration = useAppSelector(state => state.pspConfigReducer.data.footerConfiguration)
  const text: string = footerConfiguration?.text ?? footerConfiguration?.disclaimer ?? ''

  if (!text) return null

  return (
    <Box sx={{px: 2, pb: 1}}>
      <Typography
        variant="caption"
        sx={{color: NEUTRAL_SCALE[500], lineHeight: 1.4}}
      >
        {text}
      </Typography>
    </Box>
  )
}

export default FooterDisclaimer
